import { Network } from './providers/Networks/useNetworks';
import Moralis from 'moralis-v1';

interface IConfig {
	NETWORK_DEFAULT: {
		ID: Network;
		NAME: Moralis.Chain;
	};
	RPC_SERVER_DOMAIN: string;
	RPC_SERVER_ID: string;
}

const production: IConfig = {
	NETWORK_DEFAULT: {
		ID: Network.POLYGON_MAINNET,
		NAME: 'polygon',
	},
	RPC_SERVER_DOMAIN: 'https://hashup-moralis-production.up.railway.app/server',
	RPC_SERVER_ID: '001',
} as const;

const development: IConfig = {
	NETWORK_DEFAULT: {
		ID: Network.MUMBAI_TESTNET,
		NAME: 'mumbai',
	},
	RPC_SERVER_DOMAIN: 'https://cawxglhowrkc.grandmoralis.com:2053/server',
	RPC_SERVER_ID: 'vtTf7ftC58VeOXocaZuqmPKOuzozvXZgIOGON6lL',
} as const;

export const blockchainConfig = process.env.REACT_APP_ENV === 'production' ? production : development;
